import Intercom from './Intercom.component';

export default Intercom;
